





































import Vue from "vue";

import HeaderAreaType from "@/components/header-area-type.vue";
import PanelArea from "@/components/panel-area.vue";

enum AreaType {
  MALE = "male", // 男性用トイレ
  MALE_CHILDREN = "male_children", // 男性用子供トイレ
  FEMALE = "female", // 女性用トイレ
  FEMALE_CHILDREN = "female_children", // 女性用子供トイレ
  ACCESSIBLE = "accessible", // 多目的トイレ
  NURSING_ROOM = "nursing_room", // 授乳室
  POWDER_ROOM = "powder_room", // パウダールーム / パウダーコーナー
  BATH = "bath", // お風呂
  BATH_MALE = "bath_male", // お風呂 男性用
  BATH_FEMALE = "bath_female", // お風呂 女性用
  SHOWER = "shower", // シャワー
  SHOWER_MALE = "shower_male", // シャワー 男性用
  SHOWER_FEMALE = "shower_female", // シャワー 女性用
  MEETING_ROOM = "meeting_room", // 会議室
  COMMON = /* DEPRECATED */ "common", // 多目的トイレ
  WASHING_MACHINE = "washing_machine", // 洗濯機
  WASHING_MACHINE_MALE = "washing_machine_male", // 洗濯機 男性用
  WASHING_MACHINE_FEMALE = "washing_machine_female", // 洗濯機 女性用
  DRYER = "dryer", // 乾燥機
  DRYER_MALE = "dryer_male", // 乾燥機 男性用
  DRYER_FEMALE = "dryer_female", // 洗濯機 女性用
  ALL_GENDER = "all_gender", // 男性女性共用
}

export default Vue.extend({
  name: "components-stateful-section-area",
  components: {
    HeaderAreaType,
    PanelArea,
  },
  props: {
    areaType: { type: String },
    isExpandable: { type: Boolean, required: true },
    expandDefault: { type: Boolean, required: true },
  },
  data() {
    return {
      isExpanded: this.expandDefault,
    };
  },
  methods: {
    areaTypeNameByAreaType(areaType: AreaType): string {
      switch (areaType) {
        case "male":
          return "紳士化粧室";
        case "female":
          return "婦人化粧室";
        case "accessible":
        case "common":
          return "みんなのトイレ";
        case "nursing_room":
          return "授乳室";
        case "powder_room":
          return "パウダーコーナー";
        case "male_children":
        case "female_children":
          return "子供用トイレ";
        case "meeting_room":
          return "会議室";
        case AreaType.BATH:
          return "バスタブ（共用）";
        case AreaType.BATH_MALE:
          return "バスタブ（男性）";
        case AreaType.BATH_FEMALE:
          return "バスタブ（女性）";
        case AreaType.SHOWER:
          return "シャワー（共用）";
        case AreaType.SHOWER_MALE:
          return "シャワー（男性）";
        case AreaType.SHOWER_FEMALE:
          return "シャワー（女性）";
        case AreaType.WASHING_MACHINE:
          return "洗濯機（共用）";
        case AreaType.WASHING_MACHINE_MALE:
          return "洗濯機（男性）";
        case AreaType.WASHING_MACHINE_FEMALE:
          return "洗濯機（女性）";
        case AreaType.DRYER:
          return "乾燥機（共用）";
        case AreaType.DRYER_MALE:
          return "乾燥機（男性）";
        case AreaType.DRYER_FEMALE:
          return "乾燥機（女性）";
        case AreaType.ALL_GENDER:
          return "ALL GENDER";
        default:
          return "";
      }
    },
    beforeEnter(el: HTMLElement) {
      el.style.height = "0";
    },
    enter(el: HTMLElement) {
      el.style.height = el.scrollHeight + "px";
    },
    beforeLeave(el: HTMLElement) {
      el.style.height = el.scrollHeight + "px";
    },
    leave(el: HTMLElement) {
      el.style.height = "0";
    },
  },
});
